/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {SettlementReportDetailContract} from '../../../../../api/ms-settlements/settlement-export-excel/contracts/settlement-report-detail.contract';
import {SettlementReportResultDetailModel} from '../../../../models/report/settlement-report-result-detail.model';

export class SettlementReportResultDataMapper {

    private constructor() {
    }

    static fromSettlementReportDetailContractToSettlementReportResultDetailModelArray(input: readonly SettlementReportDetailContract[]):
            SettlementReportResultDetailModel[] {
        return input?.map((element) => SettlementReportResultDataMapper
                .fromSettlementReportDetailContractToSettlementReportResultDetailModel(element));
    }

    static fromSettlementReportDetailContractToSettlementReportResultDetailModel(input: SettlementReportDetailContract):
            SettlementReportResultDetailModel {
        if (input != null) {
            return {
                customer: input?.customer,
                supplier: input?.supplier,
                complaintCode: input.complaintCode,
                settlementCode: input.settlementCode,
                complaintDescription: input.complaintDescription,
                material: input.material,
                materialsTotalGrossCost: input.materialsTotalGrossCost,
                teMinutesTotalCost: input.teMinutesTotalCost,
                settlementTotalCost: input.settlementTotalCost,
                lastPendingDate: input.lastPendingDate,
                statusName: input.statusName,
                lastChangeDatetime: input.lastChangeDatetime,
                position: input?.position
            };
        }
    }
};
